
import { defineStore } from 'pinia';
import Vue from 'vue';

import { host, appointmentsClient } from "../api/config.js";

const CACHE_EXPIRY_TIME = 2 * 60 * 1000;

export const useMonthlySchedulesStore = defineStore('monthlySchedulesStore', {

    state: () => {
        return {
            schedules: {},
            selectedOfficial: null,
            selectedAppointment: {},
            currentMonthlyStats: []
        }
    },
    actions: {
        clearOfficial() {
            this.selectedOfficial = null;
        },
        selectOfficial(official) {
            console.log(official);
            this.selectedOfficial = official;
        },
        fetchMonthlyStats(year, month) {
            return new Promise((resolve, reject) => {
                appointmentsClient.fetchMonthlyCalendar(this.selectedOfficial, year, month).then(res => {
                    console.log(res);
                    if (!res.networkError && res.status == 200 && res.body) {
                        this.currentMonthlyStats = res.body;
                    }
                    resolve();
                });
            });
        },



        clearSelection() {
            this.selectedAppointment = {};
            this.selectedOfficialForReview = {};
        },
        selectAppointment(apt) {
            this.selectedAppointment = apt;
            this.selectOfficialForReview(apt.official);
        },
        selectOfficialForReview(official) {
            this.selectedOfficialForReview = official;
        },
        hasCacheExpired(officialId, date) {
            if (this.schedules[officialId] && this.schedules[officialId].length > 0) {
                let filtered = this.schedules[officialId].filter(s => s.date == date);
                if (filtered.length > 0) {
                    let ts = filtered[0].lastFetched;
                    if (Date.now() - ts < CACHE_EXPIRY_TIME) {
                        return false;
                    }
                }
            }
            return true;
        },
        
        fetchAndCacheApointments(officialId, date) {
            return new Promise((resolve, reject) => {
                if (this.hasCacheExpired(officialId, date)) {
                    console.log('appointment cache has expired');
                    let searchReq = {
                        textParams: [
                            { field: 'date', value: date, matchType: 'EXACT' },
                            { field: 'officialId', value: officialId, matchType: 'EXACT'},
                            { field: 'status', value: 'APPROVED', matchType: 'EXACT' },
                        ],
                        page: 1,
                        size: 200
                    };
                    appointmentsClient.search(searchReq).then(res => {
                        if (!res.networkError && res.body && res.body.list) {
                            
                            let obj = {
                                lastFetched: Date.now(),
                                list: this.processList(res.body.list, date),
                                date: date
                            };
                            
                            let arr = [];
                            if (this.schedules[officialId] && this.schedules[officialId].length > 0) {
                                arr = this.schedules[officialId];  
                            } 
                            arr.push(obj);
                            Vue.set(this.schedules, officialId, arr);
                            resolve();
                        } else {
                            reject();
                        }
                    });
                } else {
                    console.log('appointment cache has not expired');
                    resolve();
                }
            });
                        
        },

        processList(list, date) {
            let timelines = [];
            for (let i = 9; i < 21; i++) {
                let suffix = " AM";
                let prefix = (i + '').padStart(2, '0');
                if (i > 12) {
                    prefix = ((i - 12) + '').padStart(2, '0');
                    suffix = " PM";
                }
                
                timelines.push({ cont: false, date: date, time: prefix + ":00" + suffix, hour: i, min: 0,  appointments: []});    
                timelines.push({ cont: false, date: date, time: prefix + ":30" + suffix, hour: i, min: 30, appointments: [] });    
            }
            let prevRemainingDuration = 0;
            list.forEach(apt => {
                if (apt.visitor) {
                    if (apt.visitor.imageUrl == "") 
                        apt.visitor.imageUrl = 'images/default-avatar.jpg';
                    else
                        apt.visitor.imageUrl = host + apt.visitor.imageUrl;
                }
                if (apt.official) {
                    if (apt.official.imageUrl == "") 
                        apt.official.imageUrl = 'images/default-avatar.jpg';
                    else
                        apt.official.imageUrl = host + apt.visitor.imageUrl;
                }

                let index = timelines.findIndex(tl => (tl.hour == apt.hour && (apt.min >= tl.min && apt.min <= tl.min + 29)));
                if (index > -1) {
                    timelines[index].appointments.push(apt);
                    timelines[index].cont = false;
                    let remaining = apt.durationInMins;
                    for (let i = index + 1; i < timelines.length; i++) {
                        remaining -= 30;
                        if (remaining > 0) {
                            if (timelines[i].appointments.length == 0)
                                timelines[i].cont = true;
                            else
                                break;
                        }
                    }
                }
                
                // let filtered = timelines.filter(tl => (tl.hour == apt.hour && (apt.min >= tl.min && apt.min <= tl.min + 29)));
                // if (filtered.length > 0) {
                //     filtered[0].appointments.push(apt);
                // }
            });
            return timelines;
        },

        approveSelectedAppointment(hour, min, date, duration) {
            if (this.selectedAppointment && this.selectedAppointment.id) {
                this.selectedAppointment.durationInMins = duration;
                let filtered = this.schedules[this.selectedAppointment.officialId].filter(i => i.date == date);
                if (filtered.length > 0) {
                    let index = filtered[0].list.findIndex(tl => (tl.hour == hour && (min >= tl.min && min <= tl.min + 29)));
                    if (index > -1) {
                        filtered[0].list[index].appointments.push(this.selectedAppointment);
                        filtered[0].list.cont = false;
                        let remaining = this.selectedAppointment.durationInMins;
                        for (let i = index + 1; i < filtered[0].list.length; i++) {
                            remaining -= 30;
                            // console.log(i);
                            // console.log(remaining);
                            if (remaining > 0) {
                                // console.log("length :: " + filtered[0].list[i].appointments.length);
                                if (filtered[0].list[i].appointments.length == 0)
                                    filtered[0].list[i].cont = true;
                                else
                                    break;
                            }
                        }
                    }
                }
            }
        },
        cancelAppointment(apt) {
            return new Promise((resolve, reject) => {
                appointmentsClient.cancelAppoinment({ id: apt.appointments[0].id }).then(res => {
                    if (!res.networkError) {
                        if (res.status == 202) {
                            let filtered = this.schedules[this.selectedAppointment.officialId].filter(i => i.date == apt.date);
                            if (filtered.length > 0) {
                                
                                let index = filtered[0].list.findIndex(tl => (tl.hour == apt.hour && (apt.min >= tl.min && apt.min <= tl.min + 29)));
                                if (index > -1) {
                                    /* for now index 0 only */
                                    let remaining = apt.appointments[0].durationInMins;

                                    
                                    filtered[0].list[index].cont = false;
                                    
                                    for (let i = index + 1; i < filtered[0].list.length; i++) {
                                        remaining -= 30;
                                        
                                        if (remaining > 0) {
                                            if (filtered[0].list[i].appointments.length == 0)
                                                filtered[0].list[i].cont = false;
                                            else
                                                break;
                                        }
                                    }
                                    filtered[0].list[index].appointments = filtered[0].list[index].appointments.filter(a => a.id != apt.appointments[0].id); 
                                    
                                }
                            }
                            resolve();
                        } else {
                            reject();
                        }
                    }
                })
                
            });           
            
            
        },

        fetchStats() {
            return new Promise((resolve, reject) => {
                appointmentsClient.fetchStats().then(res => {
                    if (!res.networkError) {
                        this.stats = res.body;
                        resolve();
                    } else {
                        reject();
                    }
                })
            })
 
        }

    },

    
});
